import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: relative;
  .submitBtn {
    margin-top: 16px;
  }
`;
